// extracted by mini-css-extract-plugin
export default {"container":"Products_container__hIi0E","products":"Products_products__r7Rno","menu":"Products_menu__LJxDR","list":"Products_list__cQmCA","product":"Products_product__Dopqk"};